import { axios, APIBASE_REVIVERFEEDBACK } from "./ApiConfig";

export const declineFeedback = async (feedbackId: number) =>
  await axios.put(`${APIBASE_REVIVERFEEDBACK}api/feedback/decline/${feedbackId}`);

export const approveFeedback = async (feedbackId: number) =>
  await axios.put(`${APIBASE_REVIVERFEEDBACK}api/feedback/approve/${feedbackId}`);

export const getAllFeedback = async () => await axios.get(`${APIBASE_REVIVERFEEDBACK}api/feedback/all`);
